"use strict";

var _typeof = require("@babel/runtime-corejs3/helpers/typeof");
var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _react2 = require("@chakra-ui/react");
var _theme = _interopRequireDefault(require("../../theme"));
var _global = require("../../theme/global");
var _merge = _interopRequireDefault(require("lodash/merge"));
var _excluded = ["theme", "useLegacyOverrides", "disableExternalFonts", "children"];
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var ThemeProvider = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var theme = _ref.theme,
    useLegacyOverrides = _ref.useLegacyOverrides,
    _ref$disableExternalF = _ref.disableExternalFonts,
    disableExternalFonts = _ref$disableExternalF === void 0 ? false : _ref$disableExternalF,
    children = _ref.children,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_react2.ChakraProvider, (0, _extends2["default"])({}, props, {
    ref: ref,
    theme: (0, _merge["default"])(_theme["default"], theme)
  }), disableExternalFonts ? null : /*#__PURE__*/_react["default"].createElement(_global.Fonts, null), /*#__PURE__*/_react["default"].createElement(_global.LegacyOverrides, {
    useLegacyOverrides: useLegacyOverrides
  }), children);
});
ThemeProvider.propTypes = {
  /** If true, this will use the old `spothero-html` base styles */
  useLegacyOverrides: _propTypes["default"].bool,
  /** If true, this will not load the `Fonts` global styles */
  disableExternalFonts: _propTypes["default"].bool,
  /** The React node (generally your entire App) that will be provided the theme */
  children: _propTypes["default"].node,
  /** Adds additional themeing on top of SpotHero's default configuration */
  theme: _propTypes["default"].object
};
var _default = exports["default"] = ThemeProvider;